import { client } from "../../../Infrastructure/agent";

export const TargetService = {
  downloadTargetTemplate: (year) =>
    client.getFile("/Target/DownloadTargetTemplate", { year }),
  getAssetTargetByYear: (year, assetId) =>
    client.post("/Target/GetTargetsByYear", {
      year,
      assetId,
    }),

  saveTargets: (targets, year, uploadedBy, assetId) =>
    client.post("/Target/SaveTargets", {
      targets,
      year,
      uploadedBy,
      assetId,
    }),
  saveEquity: (equity) => client.post("/Target/SaveEquity", { equity }),
  saveMonthTarget: (target, uploadedBy) =>
    client.post("/Target/saveMonthTarget", { target, uploadedBy }),
};

